import Row from "react-bootstrap/Row";
import { Col, Nav, Navbar } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Button from "react-bootstrap/Button";
import HamburgerMenuIcon from "../AppMenu/Components/HamburgerMenuIcon";
import Dropdown from "react-bootstrap/Dropdown";
import SvgCaretDown from "./SvgCaretDown";
import IconSvg from "../SharedComponents/IconSvg";

const LandingPageHeader = ({ isHamburgerMenuActive, setIsHamburgerMenuActive }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedPage, setSelectedPage] = useState("homePage");

  const handleLanguageChange = (lang) => i18next.changeLanguage(lang);

  useEffect(() => {
    switch (location.pathname) {
      case "/": {
        setSelectedPage("landingPage");
        return;
      }

      case "/skillManagement" || "/skillAnalytics": {
        setSelectedPage("corporateServices");
        return;
      }
      case "/assessmentLibrary": {
        setSelectedPage("assessmentLibrary");
        return;
      }
      case "/individualServices": {
        setSelectedPage("individualServices");
        return;
      }
      case "/aboutUs": {
        setSelectedPage("aboutUs");
        return;
      }

      /*case "/testsAndInventories": {
        setSelectedPage("testsAndInventories");
        return;
      }*/
      /*case "/pricing": {
        setSelectedPage("pricing");
        return;
      }*/
      case "/pricing": {
        setSelectedPage("pricing");
        return;
      }
      case "/contact": {
        setSelectedPage("contact");
        return;
      }
    }
  }, [location.pathname]);

  return (
    <Navbar expand="xl" expanded={isHamburgerMenuActive} className="w-100 px-3">
      <div className="d-flex flex-grow-1 d-none d-xl-block" style={{ maxWidth: "150px" }}></div>

      <Navbar.Brand onClick={() => navigate("/")} className="d-flex  align-items-center">
        <Row className={"justify-content-center "}>
          <Col xs={"auto"} className={"align-content-center"}>
            <IconSvg icon="cp-logo" height={40} width={40} fill="#ffffff" />
          </Col>
          <Col xs={"auto"} className={"text-32 lh-1 text-color-white fw-medium d-none d-sm-block "}>
            Cus-Pro
          </Col>
        </Row>
      </Navbar.Brand>
      <div className="d-flex flex-grow-1 d-none d-xl-block" style={{ maxWidth: "150px" }}></div>

      {/* Mobile Menu Toggle */}

      <button
        className={"d-xl-none bg-white p-0 me-3 border-2  rounded-circle "}
        style={{ height: "50px", width: "50px", borderColor: "#7A7980" }}
        onClick={() => setIsHamburgerMenuActive((prevState) => !prevState)}
      >
        <HamburgerMenuIcon isOpen={isHamburgerMenuActive}></HamburgerMenuIcon>
      </button>

      {/* Main Navigation Links */}
      <Navbar.Collapse className="justify-content-between text-color-gray-light text-20 fw-medium">
        <Nav className={"d-flex column-gap-xxl-4  mx-auto ms-xxl-5"}>
          <Nav.Link
            className={`${selectedPage === "landingPage" ? "text-color-gray-dark" : ""}  me-xxl-4 text-center `}
            onClick={() => navigate("/")}
          >
            {t("landing.nav.home")}
          </Nav.Link>

          <Dropdown className="custom-dropdown align-content-center  mx-xxl-2">
            <Dropdown.Toggle
              bsPrefix={"custom-dropdown-toggle"}
              className={`fw-semibold ${selectedPage === "corporateServices" ? "text-color-gray-dark" : ""}  w-100 text-nowrap text-18`}
            >
              {t("landing.nav.corporateServices")}
              <SvgCaretDown width={14} className={"caret-icon ms-2"}></SvgCaretDown>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => {
                  navigate("/skillAnalytics");
                }}
              >
                <span className={selectedPage === "aboutUs" ? "text-color-gray-dark" : "text-color-gray-light"}>
                  {t("landing.nav.skillAnalytics")}
                </span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  navigate("/skillManagement");
                }}
              >
                <span className={selectedPage === "cusPro" ? "text-color-gray-dark" : "text-color-gray-light"}>
                  {t("landing.nav.skillManagement")}
                </span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  navigate("/assessmentLibrary");
                }}
              >
                <span className={selectedPage === "cusPro" ? "text-color-gray-dark" : "text-color-gray-light"}>
                  {t("landing.nav.assessmentLibrary")}
                </span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  navigate("/pricing");
                }}
              >
                <span className={selectedPage === "pricing" ? "text-color-gray-dark" : "text-color-gray-light"}>
                  {t("landing.nav.pricing")}
                </span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown className="custom-dropdown align-content-center text-20 mx-xxl-2">
            <Dropdown.Toggle
              bsPrefix={"custom-dropdown-toggle"}
              className={`fw-semibold ${selectedPage === "individualServices" ? "text-color-gray-dark" : ""} w-100  text-18 text-nowrap`}
            >
              {t("landing.nav.individualServices")}
              <SvgCaretDown width={14} className={"caret-icon ms-2"}></SvgCaretDown>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => {
                  navigate("/individualServices");
                }}
              >
                <span className={selectedPage === "aboutUs" ? "text-color-gray-dark" : "text-color-gray-light"}>
                  {t("landing.nav.careerAnalytics")}
                </span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  navigate("/individualServices");
                }}
              >
                <span className={selectedPage === "aboutUs" ? "text-color-gray-dark" : "text-color-gray-light"}>
                  {t("landing.nav.careerConsulting")}
                </span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Nav.Link
            className={`${selectedPage === "contact" ? "text-color-gray-dark" : ""}   ms-xxl-4  me-4 text-center`}
            onClick={() => navigate("/aboutUs")}
          >
            {t("landing.nav.aboutUs")}
          </Nav.Link>
        </Nav>

        {/* Buttons */}
        <div className="d-flex flex-grow-1 d-none d-xl-block"></div>
        <Nav className="d-flex align-items-center">
          <Row className={"ms-xxl-5"}>
            {/*<Col xs={"auto"} className={"ps-0"}>
              <Button
                className="button secondary primary-color text-18 fw-semibold"
                style={{ height: "48px", width: "150px" }}
                onClick={() => navigate("/login")}
              >
                Giriş yap
              </Button>
            </Col>*/}

            {/* Language Switcher */}
            <Col xs={"auto"} className={"ps-0 align-content-center"}>
              <Dropdown className="custom-dropdown">
                <Dropdown.Toggle bsPrefix={"custom-dropdown-toggle"} className="p-0 border-0 bg-transparent">
                  <IconSvg icon={i18next.language === "tr" ? "flag-tr" : "flag-uk"} height={24} width={24} />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item onClick={() => handleLanguageChange("tr")}>
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <IconSvg icon="flag-tr" height={20} width={20} />
                      </Col>
                      <Col>{t("turkish")}</Col>
                    </Row>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleLanguageChange("en")}>
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <IconSvg icon="flag-uk" height={20} width={20} />
                      </Col>
                      <Col>{t("english")}</Col>
                    </Row>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col xs={"auto"} className={"ps-0"}>
              <Button
                className={"button secondary primary-color h-100 rounded-pill px-2"}
                onClick={() => navigate("/contact")}
              >
                <Row className={"mx-0"}>
                  <Col className={" align-content-center "}>{t("landing.nav.contactUs")}</Col>
                </Row>
              </Button>
            </Col>
            <Col xs={"auto"} className={"px-0"}>
              <Button className={"button primary  rounded-pill px-2"} onClick={() => navigate("/login")}>
                <Row>
                  <Col className={"ps-3 pe-0 align-content-center "}>{t("landing.nav.signIn")}</Col>
                  <Col xs={"auto"}>
                    <div
                      className={"rounded-circle flex-center"}
                      style={{ backgroundColor: "#fff", width: 36, height: 36 }}
                    >
                      <IconSvg height={15} width={8} icon={"carouselArrowMirrored"} />
                    </div>
                  </Col>
                </Row>
              </Button>
            </Col>
          </Row>
        </Nav>
        <div className="d-flex flex-grow-1 d-none d-xl-block" style={{ maxWidth: "150px" }}></div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default LandingPageHeader;
